export default {
  photo: "PHOTO_FILE",
  passportPhoto: "PASSPORT_FILE",
  highSchoolDiplomaPhoto: "HIGH_SCHOOL_DIPLOMA_FILE",
  foreignLanguageProficiencyPhoto: "FOREIGN_LANGUAGE_PROFICIENCY_FILE",
};
